import { api } from '../';

export const listStates = async () => {
  return api.get('/states');
};

export const listStateCities = async (state: string) => {
  return api.get(`/states/${state}/cities`);
};
